<template>
  <div class="am-post-payment">
    <div class="am-header am-main-top-box">
      <span class="am-title am-main-top-box-title"><strong>Alert</strong></span>
    </div>
    <p v-if="!isManually" class="am-post-payment-content">Payment request did not post to the Premium Finance Company.</p>
    <p v-if="isManually" class="am-post-payment-content">Make sure to Contact your Premium Finance Company to post this payment manually.</p>
    <div class="am-blue-border"></div>
    <div class="am-buttons">
      <button type="button" class="btn btn-primary btn-xs" title="Close" @click="closeModal">Ok</button>
      <button v-if="!isManually && count > 1" type="button" class="btn btn-primary btn-xs" title="Try Again" @click="isManually = true">Post Manually</button>
    </div>
  </div>
</template>

<script>
    export default {
        name: "PostPaymentModal",
        data() {
            return {
                isManually: false
            }
        },
        props: {
            count: {
                type: Number,
                default: 1
            },
        },
        methods: {
            closeModal() {
                this.$store.dispatch('events/fireEvent', {name: 'finance-post-payment-error-close', data: this.isManually})
            }
        }
    }
</script>

<style scoped>
  .am-post-payment {
    width: 500px;
    background-color: whitesmoke;
    overflow: hidden;
  }

  .am-post-payment-content {
    padding: 15px;
  }

  .am-header {
    height: 35px;
  }

  .am-title {
    font-size: 14px;
    font-weight: bold;
    float: left;
    padding: 8px 8px 8px 15px;
  }

  .am-buttons {
    width: 100%;
    bottom: 0;
    padding: 9px 7px 10px 0;
    float: right;
  }

  .am-buttons button {
    float: right;
    margin: 0 2px 0 0;
  }

  .am-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 10px;
  }

</style>

